import { Validation } from '../../../../interfaces/common';
import {
  VALIDATION_FIELD_MAPPING,
  APP_ERROR_MESSAGES,
  Regex,
} from '../../../../utils/appConstant';

export const validateLoginForm = (formData: { email: string }, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.email) {
    if (!formData.email.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.login.blankUsername,
      });
    } else if (!Regex.email.test(formData.email.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.email,
        message: APP_ERROR_MESSAGES.login.invalidUsername,
      });
    }
  }

  return validations;
};
